import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";

import ReactDatePicker from "react-datepicker";
import LeaveHistory from "../Leave/ApplyLeave/LeaveHistory";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../../constants";
import moment from "moment";
import LeaveSummary from "../Leave/ApplyLeave/LeaveSummary";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";

const ViewCompOff = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [summaryLeave, setSummaryLeave] = useState([]);
  const [CompHistory, setCompHistory] = useState([]);
  const [projectOpt, setProjectOpt] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [statusoptions, setStatusOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [disabledDatess, setDisabledDatess] = useState([]);
  const [daysDifference, setDaysDifference] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);
  const [formData, setFormData] = useState({
    ProjectID: null,
    Purpose: "",
    ActionRemarks:"",
    FromDate: null,
    ToDate: null,
    days: "",
    ApplicationStatus_123: statusoptions[0]?.value || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSelectChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      ProjectID: selectedOption ? selectedOption.value : null,
    }));
  };
  useEffect(() => {
    if (formData.FromDate != "" && formData.ToDate != "") {
      calculateDays(formData.FromDate, formData.ToDate);
    }
  }, [formData.FromDate, formData.ToDate]);

  const handleDateChange = (date, name) => {
    const selectedMonth = date?.getMonth();
    if (name === "FromDate") {
      setFormData((prevState) => ({
        ...prevState,
        FromDate: date,
        ToDate: date,
        days: 1,
      }));
      // setDaysDifference(1);
    } else {
      // if (date?.getMonth() !== formData?.FromDate?.getMonth()) {
      //   toast.error("FromDate and ToDate must be in the same month");
      //   return;
      // }
      setFormData((prevState) => ({
        ...prevState,
        [name]: date,
      }));
      calculateDays(formData.FromDate, date);
    }
  };

  const calculateDays = (fromDate1, toDate1) => {
    const fromDate = new Date(`${fromDate1}`);
    const toDate = new Date(`${toDate1}`);

    if (fromDate && toDate) {
      let currentDate = new Date(fromDate);
      let daysDiff = 0;      

      while (currentDate <= toDate) {
        if (isWeekday(currentDate)) {
          daysDiff++;
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      setFormData((prevState) => ({
        ...prevState,
        days: daysDiff,
      }));
    }
  };

  const fetchHolidayDates = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}weekends-holidays`);
      if (response.status === 200) {
        const weekendHoliday = response?.data?.dates.map(
          (date) => new Date(date)
        );
        setDisabledDatess(weekendHoliday);
        // setPageLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Weekend Holiday details:", error);
    }
  };
  useEffect(() => {
    fetchHolidayDates();
  }, []);

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}apply-compOff/${id}`);
      if (response.status === 200) {
        const leaveData = response?.data?.compOffData;
        const compOffLeave = response?.data?.project;
        const projectOpt = compOffLeave.map((comp) => ({
          value: comp.value,
          label: comp.text,
        }));
        setProjectOpt(projectOpt);
        const compOffHistory = response?.data?.compOffHistory;
        setCompHistory(compOffHistory);
        const leaveSummary = response?.data?.leaveSummary;
        setSummaryLeave(leaveSummary);

        const statusoption = response.data.status;
        const filteredStatus = statusoption.filter(
          (comp) => comp.value === 1132 || comp.value === 824
        );
        const statusopt = filteredStatus.map((comp) => ({
          value: comp.value,
          label: comp.text,
        }));
        setStatusOptions(statusopt);
        if (leaveData) {
          const { ProjectID, Purpose,ActionRemarks, FromDate, ToDate } = leaveData;
          setFormData({
            id: id || "",
            ProjectID: ProjectID || "",
            Purpose: Purpose || "",
            ActionRemarks:ActionRemarks || "",
            FromDate: FromDate ? moment(FromDate).format("DD-MMM-YYYY") : "",
            ToDate: ToDate ? moment(ToDate).format("DD-MMM-YYYY") : "",
            ApplicationStatus_123: leaveData?.ApplicationStatus_123,
          });
        } else {
          console.error("Leave Data not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch Leave details. Server responded with status:",
          response.status
        );
      }
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching Leave details:", error);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, []);


  const isWeekday = (date) => {
    const currentDate = new Date();  
    const currentMonth = currentDate.getMonth();    
    const currentYear = currentDate.getFullYear();


    // Get the first day of the next month
    const nextMonth = new Date(currentYear, currentMonth + 1, 1);

    // Get the first day of the current month
    const firstOfCurrentMonth = new Date(currentYear, currentMonth, 1);

    // Check if the date is in the last 3 months or next month
    const isInLastThreeMonths =
      date >= new Date(currentYear, currentMonth - 3, 1) &&
      date < firstOfCurrentMonth;
    const isInNextMonth = date >= nextMonth;

    // Disable all dates for the next month
    if (isInNextMonth) {
      return false;
    }
    const isHoliday =
      Array.isArray(disabledDatess) &&
      disabledDatess.some((holidayDate) => {
        const holiday = new Date(holidayDate); // Ensure holidayDate is a Date object
        return holiday.toDateString() === date.toDateString();
      });

    if (isHoliday) {
      return true; // Enable the holiday dates
    }

    return false; // Disable all other dates
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Comp Off Report"));
  }, []);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.Purpose) newErrors.Purpose = "Purpose is required";
    if (!formData.project) newErrors.project = "Project is required";
    if (!formData.FromDate) newErrors.FromDate = "From Date is required";
    if (!formData.ToDate) newErrors.ToDate = "To Date is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Format the form data
    const formattedData = {
      ...formData,
      // ApplicationStatus_123: selectedStatus,
      FromDate: formData.FromDate
        ? moment(formData.FromDate).format("YYYY-MM-DD")
        : null,
      ToDate: formData.ToDate
        ? moment(formData.ToDate).format("YYYY-MM-DD")
        : null,
    };
    try {
      // Make a PUT request using Axios
      const response = await PostServiceCaller(
        `${API_URL}apply-compOff/${id}`,
        formattedData,
        "put"
      );

      setSubmit(true); // Set the submit state to true
      toast.success("Comp Off updated successfully!");

      // Navigate to the desired route
      navigate("/apply-comp-off");
    } catch (error) {
      console.error("There was an error!", error);
      if (error.response) {
        console.error("Error Response Data:", error.response.data); // Log the error response
      }

      toast.error("Failed to update Comp Off. Please try again.");
      setSubmit(false); // Set the submit state to false in case of an error
    }
  };

  const handleCancel = () => {
    navigate("/approve-comp-off");
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-7 apply-Leave">
              <div className="container-fluid" id="skill-table-area">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <label htmlFor="project" className="form-label">
                        Employee
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={CompHistory?.[0]?.EmployeeName || ""}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="project" className="form-label">
                        Project<span className="required">*</span>
                      </label>
                      <Select
                        options={projectOpt}
                        isDisabled={true}
                        onChange={(option) =>
                          setFormData({
                            ...formData,
                            project: option,
                          })
                        }
                        value={projectOpt.find(
                          (ele) => ele?.value === formData.ProjectID
                        )}
                      />
                      {errors.project && (
                        <div className="invalid-feedback">{errors.project}</div>
                      )}
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6 mt-2">
                      <label htmlFor="Purpose" className="form-label">
                        Purpose<span className="required">*</span>
                      </label>
                      <textarea
                        className={`form-control ${
                          errors.Purpose ? "is-invalid" : ""
                        }`}
                        id="Purpose"
                        aria-describedby="Purpose"
                        name="Purpose"
                        value={formData.Purpose}
                        onChange={handleInputChange}
                        disabled
                      />
                      {errors.Purpose && (
                        <div className="invalid-feedback">{errors.Purpose}</div>
                      )}
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="Purpose" className="form-label">
                        Remark
                      </label>
                      <textarea
                        className={`form-control ${
                          errors.Purpose ? "is-invalid" : ""
                        }`}
                        id="ActionRemarks"
                        aria-describedby="ActionRemarks"
                        name="ActionRemarks"
                        value={formData.ActionRemarks}
                        onChange={handleInputChange}
                        disabled
                      />
                      {errors.Purpose && (
                        <div className="invalid-feedback">{errors.Purpose}</div>
                      )}
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-sm-12 col-md-3 mt-2">
                      <label htmlFor="FromDate" className="form-label">
                        From Date<span className="required">*</span>
                      </label>
                      <ReactDatePicker
                        autoComplete="off"
                        showPopperArrow
                        showIcon
                        disabled={true}
                        className={`form-control ${
                          errors.FromDate ? "is-invalid" : ""
                        }`}
                        name="FromDate"
                        id="FromDate"
                        filterDate={isWeekday}
                        dateFormat="dd-MMM-yyyy"
                        selected={formData.FromDate}
                        onChange={(date) => handleDateChange(date, "FromDate")}
                        maxDate={moment().endOf("month").toDate()}
                      />
                      {errors.FromDate && (
                        <div className="invalid-feedback">
                          {errors.FromDate}
                        </div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-3 mt-2">
                      <label htmlFor="ToDate" className="form-label">
                        To Date<span className="required">*</span>
                      </label>
                      <ReactDatePicker
                        autoComplete="off"
                        showPopperArrow
                        showIcon
                        disabled={true}
                        filterDate={isWeekday}
                        className={`form-control ${
                          errors.ToDate ? "is-invalid" : ""
                        }`}
                        name="ToDate"
                        id="ToDate"
                        dateFormat="dd-MMM-yyyy"
                        selected={formData.ToDate}
                        onChange={(date) => handleDateChange(date, "ToDate")}
                        maxDate={moment().endOf("month").toDate()}
                  
                      />
                      {errors.ToDate && (
                        <div className="invalid-feedback">{errors.ToDate}</div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-2 mt-2">
                      <div className="mb-3">
                        <label htmlFor="days" className="form-label">
                          No. of Days
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          id="days"
                          aria-describedby="days"
                          name="days"
                          value={formData.days}
                          // value={daysDifference}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-4 mt-2">
                      <div className="mb-3">
                        <label htmlFor="days" className="form-label">
                          Status
                        </label>
                        <Select
                          value={statusoptions.find(
                            (option) =>
                              option.value === formData.ApplicationStatus_123
                          )}
                          options={statusoptions}
                          isDisabled={true}
                          onChange={(option) => {
                            if (
                              option.value !== formData.ApplicationStatus_123
                            ) {
                              // setSelectedStatus(option.value);
                              setFormData((prev) => ({
                                ...prev,
                                ApplicationStatus_123: option.value,
                              }));
                            }
                          }}
                        />
                      </div>
                    </div>
                    </div>

                  <div className="d-flex justify-content-between mt-2">
                    <h6 className="mt-1">
                      * Comp Off can be applied only for non-working days.
                    </h6>
                    <div>
                      <button
                        type="button"
                        className="cancel-btn me-2"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      {/* <button type="submit" className="custom-btn">
                        update
                      </button> */}
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-12 col-lg-5 apply-Leave">
                <LeaveSummary leaveDetails={summaryLeave} />
                <LeaveHistory
                  leaveHistory={CompHistory}
                  showAction={false}
                  title="Comp-Off History"
                />
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default ViewCompOff;
